import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import backArrowIcon from "assets/images/back-arrow.svg";
import "./Settings.scss";
import Widgets from "./Widgets";
import Subheader from "layout/non-auth-layout/sub-header/Subheader";
import UserContext from "store/user-context";
import LoaderFull from "../../shared/loader/LoaderFull";

const SettingsLayout = () => {
  const [isPageLoading, setisPageLoading] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [isEditMode, setisEditMode] = useState(false);
  const userCtx = useContext(UserContext);
  const userRole = userCtx.userRole;

  const [state, setState] = useState({
    autoConfirmOrders: true,
    printTwoReceipts: true,
    muteNotificationSound: true,
    revenueShare: false,
    totalOrders: false,
    completedOrdersCount: true,
    averageValue: true,
    totalRevenue: true,
    cancelledOrders: true,
    deliveryBHBCommission: true,
    taxes: true,
    errorCharges: true,
    errorRate: true,
    restaurantOwner: true,
    restaurantStaff: true,
    brandOwner: true,
    affiliateUser: true,

  });

  const onSubmit = (data) => {
    setisLoading(true)
    setTimeout(()=>{
      setState(data);
      setisLoading(false);
      setisEditMode(false);
    }, 2000)
    console.log({submitted: data})
  }
  return (
    <>
      <Subheader>
        <div className="goBack mb-3">
          <Link
            to="/dashboard"
            className="back-btn-red"
            title="Go to Dashboard"
          >
            <span className="icons">
              <img src={backArrowIcon} alt="back icon" />
            </span>
            Go to Dashboard
          </Link>
        </div>
      </Subheader>
      {
        isPageLoading ? <LoaderFull /> : 
        <div className="reports__wrapper">
          <div className="orders__page__wrapper">
            <div className="managermodifier__wrapper basic__info__content">
              <div className="container">
                <div className="managermodifier__header">
                  <div className="row justify-content-between">
                    <div className="col-12 mb-3 pb-3 d-none d-md-block">
                      <div className="goBack">
                        <Link
                          to="/dashboard"
                          className="back-btn-red"
                          title="back to home"
                        >
                          <span className="icons">
                            <img src={backArrowIcon} alt="back icon" />
                          </span>
                          Go to Dashboard
                        </Link>
                      </div>
                    </div>
                    <div className="col-12 d-flex justify-content-between">
                      <h1>Settings</h1>
                    </div>
                  </div>
                </div>
                <section className="sections">
                  <div className="row">
                    <div className="col-12">
                      <Widgets
                        userRole={userRole}
                        data={state}
                        onSubmit={onSubmit}
                        isLoading={isLoading}
                        isEditMode={isEditMode}
                        setisEditMode={setisEditMode}
                      />
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default SettingsLayout;
